module.exports = __webpack_public_path__ + "static/media/instructor-brady.24728e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructor-brady.png
// module id = 356
// module chunks = 0